import React from "react";
import { others } from "../indexAssets";
import { truncateFloat } from "../../../../helpers/generalHelper";
import "..//project.css";

const TableProject = ({ hoursBudget, hoursWorked }) => {
    const { verticalLine } = others;

    const workingHours = truncateFloat(hoursWorked);
    const budgetHours = truncateFloat(hoursBudget);
    const difference = truncateFloat(budgetHours - workingHours);

    return (
        <div className="w-full h-fit flex items-end justify-center gap-2">
            <div className="w-16">
                <p className="text-[10px] font-semibold text-[#282828] text-center hidden"></p>
                <p className="h-6 text-[#282828] text-[10px] font-semibold leading-normal text-center mt-3">Total</p>
            </div>
            <img src={verticalLine} alt="separator" />
            <div className="w-16">
                <p className="text-[10px] font-semibold text-[#282828] text-center">Horas presupuesto</p>
                <p className="h-6 text-[#282828] text-[10px] font-normal leading-normal text-center mt-3">{budgetHours}</p>
            </div>
            <img src={verticalLine} alt="separator" />
            <div className="w-16">
                <p className="text-[10px] font-semibold text-[#282828] text-center">Horas Trabajadas</p>
                <p className="h-6 text-[#282828] text-[10px] font-normal leading-normal text-center mt-3">{workingHours}</p>
            </div>
            <img src={verticalLine} alt="separator" />
            <div className="w-16">
                <p className="text-[10px] font-semibold text-[#282828] text-center">Diferencias</p>
                <p className="h-6 text-[#282828] text-[10px] font-normal leading-normal text-center mt-3">{difference}</p>
            </div>
        </div>
    );
};

export default TableProject;
